<template>
  
  <div class="videoCont">

      <div class="yourAd">Rewarded ad sample</div>

      <div class="count" @click="$emit('close-video')"></div>

        <img src="assets/video/nirva.png" id="adImg">

        <video width="100%" height="100%" id="videoSrc">
          <source src="assets/video/nirva.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>

  </div>

</template>

<script>
  export default {

  name: 'videoCont',

  props: [ "videoMov" ],

  data (){
    return {
      timeLeft: 5,
      timerId: {}
    }
  },

  mounted() {
    document.querySelector('#videoSrc').play()
    this.playS()
  },

  methods: {

    playS(){

      this.timerId = setInterval(this.countdown, 1000)
      document.querySelector('.Quest').classList.add('noCurslide')

    },

    countdown(){

      
      let elem = document.querySelector('.count')

      if (this.timeLeft == 0) {

        clearTimeout(this.timerId);
        // document.querySelector('.videoCont').classList.add('adActive')
        document.querySelector('.count').innerHTML = 'Close'
        document.querySelector('.count').classList.add('closeActive')
        // document.querySelector('#videoSrc').pause()
        
      } else {

        elem.innerHTML = this.timeLeft;
        this.timeLeft--;

      }
    }
  },

  watch: { 
    videoMov: function(newVal, oldVal) { // watch it
      if(newVal){
        document.querySelector('.videoCont').classList.remove('adActive')
        this.timeLeft = 5;
        setTimeout( () => { 
          this.playS()
         }, 10)
        
      } else {
        clearTimeout(this.timerId);
        document.querySelector('.videoCont').classList.remove('adActive')
        this.timeLeft = 5;
      }
      
    }
  }

}
</script>

  <style>

    .videoCont{
      height: 100%;
      width: 100%;
      z-index: 3;
      position: relative;
      display: flex;
      overflow: hidden;
      position: absolute;
      top: 0;
      background: #000;
    }

    .videoCont img{
      height: auto;
      width: contain;
      position: absolute;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      display: none;
    }

    .adActive img{
      display: block;
    }

    .count{
      position: absolute;
        top: 0;
        right: 0;
        z-index: 3;
        padding: 12px;
        background: rgba(0,0,0, 0.85);
        opacity: 0.5;
        font-family: arial;
        font-size: 14px;
        color: #fff;
    }

    .closeActive{
      background: #fff;
      color: #000;
      opacity: 1;
    }


    #playVid{
      position: absolute;
      bottom: 0;
      right: 50%;
    }

  .noCurslide .curSlide{
    display: none;
  }

  .yourAd{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    padding: 12px;
    background: rgba(0,0,0,0.5);
    opacity: 0.5;
    font-family: arial;
    font-size: 14px;
    padding-left: 12px;
    border-radius: 0 0 12px 0;
  }


  </style>